import type { DeployAccessPolicy } from '../../../core/types';
import type { AppInstanceFieldKey } from '../fields';
import { APP_INSTANCE_FIELD_KEYS } from '../fields';

/**
 * capability 注册 field → AppInstance 逻辑 field。
 * 基本信息已统一为 `base.*`；其余仍按 `app.*` / 别名决策。
 */
export const APP_INSTANCE_CAPABILITY_FIELD_ALIASES: Record<string, AppInstanceFieldKey> = {
  'envVars.list': 'app.commonEnv',
  'healthCheck.config': 'app.healthCheck',
  'service.list': 'app.inferenceService',
  'mi.framework': 'app.framework',
  'mi.inferenceSystem': 'app.inferenceSystem',
  'mi.inferenceSource': 'app.inferenceSystem',
  'mi.inferenceFrameworkImage': 'app.framework',
  'mi.runMode': 'app.runMode',
  'mi.masterNodes': 'app.masterNodes',
  'mi.workerNodes': 'app.workerNodes',
};

const APP_FIELD_SET = new Set<string>(APP_INSTANCE_FIELD_KEYS);

/**
 * 将 AppInstance accessPolicy 适配为 capability buildCapabilityControl 可用的策略。
 * 未映射的 capability field 默认 editable（避免误锁自定义 UI）。
 */
export function adaptAppInstanceAccessPolicy(policy: DeployAccessPolicy<AppInstanceFieldKey>): DeployAccessPolicy<string> {
  return {
    field: (field) => {
      const aliased = APP_INSTANCE_CAPABILITY_FIELD_ALIASES[field];
      if (aliased) return policy.field(aliased);
      if (APP_FIELD_SET.has(field)) return policy.field(field as AppInstanceFieldKey);
      return 'editable';
    },
    action: (action) => policy.action(action),
  };
}
